export default __webpack_public_path__ + "static/media/single-both-border-left.1663d4e4.svg";